import styled from "styled-components";
import Colors from "./../../global/color";
import FontSizes from './../../global/Typography/FontSizes';

export const StyledContainer = styled.div`
  padding: 50px;
`;

export const StyledH2 = styled.h2`
  font-size: ${FontSizes.extraLarge}px;
  color: ${Colors.goldDark};
`;
